import React, {Component} from 'react';
import SmartDialog from "../../../../components/SmartDialog";
import {Field, Form, Formik} from "formik";
import {Button, Label} from "reactstrap";
import FormInput from "../../../../components/FormInput";
import MDProgress from "react-md-progress-bar";
import {BindingValidationSchema, DefaultBindingProduct} from "./USSDServicesCommon";
import PropTypes from 'prop-types';
import {MiscEndpoints, USSDEndpoints} from "../../../../common/ProxyEndpoints";
import HTML from '../../../../common/HtmlHelpers';
import Utils from "../../../../common/Utils";
import TTLProxy from "../../../../common/TTLAsyncProxy";

class CreateBindingDialog extends Component{

    static propTypes = {
        onCreate: PropTypes.func,
        service: PropTypes.object
    };

    constructor(props){
        super(props);
        this.state = CreateBindingDialog.getInitialState();
        this.proxy = TTLProxy.getInstance();
    }

    static getInitialState(state){

        return {
            groups: [],
            enableGroupSelect: state ? state.enableGroupSelect : false,
            pricingGroup:  state  ? state.pricingGroup : null
        };

    }

    async loadState(){

        this.setState({ isBusy: true });

        try {

            const res = await this.proxy.processRequest(MiscEndpoints.getPricingGroups());

            this.setState({
                groups: res.getPayload()
            });

        }
        catch (e) {

            HTML.toastError(Utils.getResponseError(e));

            this.setState({
                error: e
            });

        }
        finally {

            this.setState({
                 isBusy: false
            });

        }

    }

    show(pricingGroup,enableGroupSelect){

        this.setState(CreateBindingDialog.getInitialState({  pricingGroup, enableGroupSelect }) , async () => {

            //
            if(enableGroupSelect)
                await this.loadState();

            //  show dialog
            this._dlg.show();

        });

    }

    async onSubmit(values){

        try{

            const res = await this.proxy.processRequest(USSDEndpoints.createServiceBinding(this.props.service.id,{
                group_id: values.pricingGroup,
                product: values.isDefaultProduct ? DefaultBindingProduct : values.product,
                cost: values.cost
            }));

            if(res.ok){

                //  toast success
                HTML.toastSuccess('Price definition created successfully');

                if(this.props.onCreate)
                    this.props.onCreate(res.getPayload());

                //
                this._dlg.hide();
            }

        }
        catch (e) {
            HTML.toastError(Utils.getResponseError(e));
        }
    }

    render(){

        const { enableGroupSelect , groups , pricingGroup } = this.state;

        return <SmartDialog title="Create Price Definition" ref={r => this._dlg = r}>

            <Formik initialValues={{
                        isDefaultProduct: false,
                        product: '',
                        cost: 1,
                        pricingGroup: pricingGroup ? pricingGroup.id :  (groups.length > 0 ? groups[0].id : '')
                    }}
                    enableReinitialize
                    ref={r => this._form = r}
                    validationSchema={BindingValidationSchema}
                    onSubmit={async (values,{ setSubmitting }) => {

                        try{
                            await this.onSubmit(values);
                        }
                        catch (e) {

                            //  Failed submitting

                        }
                        finally {
                            setSubmitting(false);
                        }

                    }}>
                {({ isValid , isSubmitting , values }) => (<Form>


                    {enableGroupSelect && <FormInput   name="pricingGroup"
                                                       type="select"
                                                       items={groups.map(x => ({ value: x.id , text: x.name }))}
                                                       title={"Price Segment"}
                                                       required={true}/>}


                    <div className="clearfix">

                        <div className="pull-left">
                            <Label for={"product"}><i className="fa fa-book"/> Product</Label>
                        </div>

                        <div className="pull-right">
                            <Field name="isDefaultProduct">
                                {({ field , form: { setFieldValue }}) =>{
                                    return <label><input type="checkbox" checked={field.value} onChange={evt => setFieldValue("isDefaultProduct",evt.target.checked)}/> Is Default Product</label>
                                }}
                            </Field>
                        </div>

                    </div>

                    <FormInput name="product"
                               type="text"
                               placeholder={"Enter product name"}
                               required={true}
                               disabled={values.isDefaultProduct}/>

                    <FormInput name="cost"
                               title={<span><i className="fa fa-money"/> Cost</span>}
                               type="number"
                               min={0}
                               placeholder={"Enter cost of product in region"}
                               required={true}/>

                    <hr/>

                    {isSubmitting && <MDProgress show overlay/>}

                    <Button color="green" disabled={!isValid || isSubmitting} block><i className="fa fa-edit"/> Save Changes</Button>


                </Form>)}
            </Formik>

        </SmartDialog>
    }

}

export default CreateBindingDialog;


// WEBPACK FOOTER //
// ./src/views/Extras/Services/USSDServices/CreateBindingDialog.js